import { authedRequest } from './requests';
import { normalize, schema } from 'normalizr';

// Define schema
const channelTheme = new schema.Entity('channelThemes');

const channelThemeList = [channelTheme];

const channel = new schema.Entity('allChannels', {
  client: new schema.Entity('clients')
});

/**
 *
 * /channels resource requests
 *
 */
export const getChannelThemes =
  (token) =>
    authedRequest('v2/channel_themes', token)
      .then(r => normalize(r, channelThemeList).entities);

export const postChannelTheme =
  (token, id, { channel_theme_id, first_line_text, second_line_text }) =>
    authedRequest(`v2/channels/${id}/theme_instance`, token, {
      method: 'POST',
      body: JSON.stringify({
        theme_instance: {
          channel_theme_id,
          first_line_text,
          second_line_text
        }
      })
    }).then(r => normalize(r, channel).entities);
